var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },
  {
    id: "department",
    label: "部署名",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
      excess_deficiency_summary_department:"A",
      excess_deficiency_summary_all:"A",
      excess_deficiency_summary_team:"A",
      excess_deficiency_summary_system:"B",
    },
  },
  {
    id: "team",
    label: "チーム名",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
      excess_deficiency_summary_team:"B",
    },
  },
  {
    id: "system_name",
    label: "システム名",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
      excess_deficiency_summary_system:"A"
    },
  },
  {
    id: "item_number",
    label: "総本数",
    field_type:"number",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
      excess_deficiency_summary_department:"B",
      excess_deficiency_summary_all:"B",
      excess_deficiency_summary_team:"C",
      excess_deficiency_summary_system:"C",
    },
  },
  
  {
    id: "number_to_be_linked",
    label: "紐付対象数",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
      excess_deficiency_summary_department:"C",
      excess_deficiency_summary_all:"C",
      excess_deficiency_summary_team:"D",
      excess_deficiency_summary_system:"D",
    },
  },
  {
    id: "number_of_link",
    label: "紐付数",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
      excess_deficiency_summary_department:"D",
      excess_deficiency_summary_all:"D",
      excess_deficiency_summary_team:"E",
      excess_deficiency_summary_system:"E",
    },
  },
  {
    id: "number_of_unlinked",
    label: "未紐付数",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
      excess_deficiency_summary_department:"E",
      excess_deficiency_summary_all:"E",
      excess_deficiency_summary_team:"F",
      excess_deficiency_summary_system:"F",
    },
  },
  {
    id: "linking_rate",
    label: "紐付率",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
      excess_deficiency_summary_department:"F",
      excess_deficiency_summary_all:"F",
      excess_deficiency_summary_team:"G",
      excess_deficiency_summary_system:"G",
    }
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_excess_deficiency_summary.js